
import di from 'dependeny-injection';


import './model/info_log.js';

import common_article_header from './../common/tags/article/common_article_header.riot'
import common_article_breadcrumbs from './../common/tags/article/common_article_breadcrumbs.riot'

import info_logs_base_area from './tags/contents/info-logs/info_logs_base_area.riot'

di.riot.register('common_article_header',common_article_header);
di.riot.mount('common_article_header',common_article_header);

di.riot.register('common_article_breadcrumbs',common_article_breadcrumbs);
di.riot.mount('common_article_breadcrumbs',common_article_breadcrumbs);



di.riot.register('info_logs_base_area',info_logs_base_area);
di.riot.mount('info_logs_base_area',info_logs_base_area);

